import React, { useEffect, useState } from 'react'
import styles from '../BlocksPage/index.module.sass'
import { Search } from '../../ui/Search'
import prev from '../../../assets/arrow_prev.svg'
import next from '../../../assets/arrow_next.svg'
import classNames from 'classnames'
import { BlockItems } from './BlockItems'
import { BlockList, getBlocks } from '../../../services/BlocksPageService'

const previousParams: Record<string, string>[] = []
let currentParams: Record<string, string> = {}
let page = 1

export const BlocksPage = () => {
    const [blockList, setBlocks] = useState<BlockList>({
        items: [],
        next_page_params: null,
    })
    const previousPageHandler = () => {
        if (previousParams.length > 0) {
            page = page - 1
            currentParams = previousParams.pop() || {}
            getBlocks(setBlocks, currentParams)
        }
    }
    const nextPageHandler = () => {
        if (blockList.next_page_params) {
            previousParams.push(currentParams)
            currentParams = blockList.next_page_params
            page = page + 1
            getBlocks(setBlocks, currentParams)
        }
    }
    useEffect(() => {
        getBlocks(setBlocks, {})
    }, [])
    const isDisabled = page == 1
    return (
        <div>
            <section className={styles.pageSection}>
                <div className={classNames(styles.headOfPage, styles.jcsb)}>
                    <p>Blocks</p>
                </div>

                <div>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <thead className={styles.tableHead}>
                                <tr>
                                    <th className={styles.paddingitem}>
                                        Block
                                    </th>
                                    <th className={styles.paddingitem}>
                                        Size, bytes
                                    </th>
                                    
                                    <th className={styles.paddingitem}>
                                        Validator
                                    </th>
                                    
                                    <th className={styles.paddingitem}>
                                        Txn
                                    </th>
                                    
                                    <th className={styles.paddingitem}>
                                        Gas used
                                    </th>
                                    
                                    <th className={styles.paddingitem}>
                                        Reward ETH
                                    </th>
                                    
                                    <th className={styles.paddingitem}>
                                        Burnt fees ETH
                                    </th>
                                </tr>
                            </thead>
                            <BlockItems
                                BlockArray={blockList.items}
                            ></BlockItems>
                        </table>
                    </div>
                    <div className={styles.paginationButtons}>
                        <button
                            className={styles.controlButton}
                            disabled={isDisabled}
                            onClick={previousPageHandler}
                        >
                            <img src={prev} alt="previous page" />
                        </button>
                        <div className={styles.pageNum}>{page}</div>
                        <button
                            className={styles.controlButton}
                            onClick={nextPageHandler}
                            disabled={
                                !blockList.next_page_params
                            }
                        >
                            <img src={next} alt="next page" />
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}
